import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [{
    path: '/index',
    name: 'index',
    component: () => import('@/views/index'),
  },
  {
    path: '/',
    name: '/',
    component: () => import('@/views/index'),
  },
  {
    path: '/qudong',
    name: 'qudong',
    component: () => import('@/views/qudong'),
  },
  {
    path: '/qyserve',
    name: 'qyserve',
    component: () => import('@/views/qyserve'),
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('@/views/case'),
  },
  {
    path: '/about_us',
    name: 'about_us',
    component: () => import('@/views/about_us'),
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news'),
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/details'),
  },
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () => import('@/views/privacypolicy'),
  }
  // {
  //   path: '/collect_card_gnxk2024/:id',
  //   name: 'collect_card_gnxk2024',
  //   component: () => import('@/views/gnxk/index'),
  // },
  // {
  //   path: '/gnxk_list/:id/:level/:sort',
  //   name: 'gnxk_list',
  //   component: () => import('@/views/gnxk/list'),
  // },
  // {
  //   path: '/gnxk_result/:id/:level/:sort',
  //   name: 'gnxk_result',
  //   component: () => import('@/views/gnxk/result'),
  // },
  // {
  //   path: '/gnxk_name_list/:id',
  //   name: 'gnxk_name_list',
  //   component: () => import('@/views/gnxk/name_list'),
  // }
]
const createRouter = () => new Router({
  mode: 'history', // require service support
  routes: constantRoutes,
  scrollBehavior(to, from, savePosition) { //eslint-disable-line
    if (savePosition) return savePosition;
    else return { x: 0, y: 0 }
  }
})
const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/router/index.js